import React, { useEffect, useRef, useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Text from 'components/base/Text';
import { withStyles } from '@material-ui/core/styles';

const TooltipWrapper = withStyles({
  popper: {
    zIndex: 1700
  }
})(Tooltip);

const TextWithTooltipOnEllipsis = props => {
  const textRef = useRef(null);
  const [shouldShowTooltip, setShouldShowTooltip] = useState(false);
  const isEllipsisActive = ({ current }) =>
    current &&
    (current.offsetHeight < current.scrollHeight ||
      current.offsetWidth < current.scrollWidth);
  useEffect(() => {
    if (textRef) {
      setShouldShowTooltip(isEllipsisActive(textRef));
    }
  }, [textRef]);
  return (
    <TooltipWrapper
      title={props.children || ''}
      disableHoverListener={!shouldShowTooltip}
    >
      <Text {...props} ref={textRef}>
        {props.children}
      </Text>
    </TooltipWrapper>
  );
};

export default TextWithTooltipOnEllipsis;
